import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import AppSelection from './components/AppSelection';
import PrayerCounterApp from './apps/prayer-counter/PrayerCounterApp';
import RandomCounterApp from './apps/random-counter/RandomCounterApp';
import Settings from './components/Settings';
import { AuthProvider } from './contexts/AuthContext';
import AuthGuard from './components/AuthGuard';
import ErrorBoundary from './components/ErrorBoundary';
import NetworkStatus from './components/NetworkStatus';

// Saffron theme for Ant Design
const theme = {
  token: {
    colorPrimary: '#FF8C00',
    colorInfo: '#FF8C00',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    borderRadius: 8,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Button: {
      borderRadius: 8,
      fontWeight: 600,
    },
    Card: {
      borderRadius: 12,
    },
    Input: {
      borderRadius: 8,
    },
    Modal: {
      borderRadius: 12,
    },
  },
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <HelmetProvider>
          <ConfigProvider theme={theme}>
            <AuthGuard>
              <div style={{ 
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #FFF8F0 0%, #FFFFFF 100%)'
              }}>
                <NetworkStatus />
                <Routes>
                  <Route path="/" element={<AppSelection />} />
                  <Route path="/apps/prayer-counter/*" element={<PrayerCounterApp />} />
                  <Route path="/apps/random-counter/*" element={<RandomCounterApp />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </div>
            </AuthGuard>
          </ConfigProvider>
        </HelmetProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App; 